import React from 'react'
import styles from './Loading.module.scss'
import '../loadingOverlay/cssSpinner.css'
import { Box, BoxProps } from '@mui/material'

interface Props extends BoxProps {

}

const Loading:ReactFC<Props> = ({ ...boxProps }) => {
  return (
    <Box
      className={styles.loadingContainer}
      {...boxProps}
    >
      <div className='lds-ring'>
        <div />
        <div />
        <div />
        <div />
      </div>
    </Box>
  )
}

export default Loading
